<template>
    <div>
        <label>{{label}}</label>
        <div class="form-control-wrap form-datepicker">
            <v-datepicker v-model="content" type="text"
            autocomplete="off" class="form-control datepicker"
            pattern="(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](18|19|20)\d\d">
            </v-datepicker>
            <span class="form-control-date-custom"></span>
        </div>
        <small class="form-text text-danger">Value is invalid.</small>
    </div>
</template>
<script>
    export default {
        props: ["label", "model"],
        data: function(){
            return {
                content: this.model
            }            
        },
        watch:{
            content(val){
                this.$emit("update:model", val);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/layout/datepicker.vue